export const VARIANT_TYPE = 'PRODUCTO_VARIANTE';
export const COLOR_CONSTANT = 'COLOR';
export const SIZE_CONSTANT = 'TALLA';